import React from "react";

const ConnectSourceCatalogIcon = ({ source }) => {
  if (source?.Icon) {
    const Icon = source.Icon;
    return <Icon className="business-catalog-app-icon__svg" {...(source.iconProps || {})} />;
  }

  if (source?.initial) {
    return (
      <span
        className="business-catalog-app-icon__initial"
        style={{ background: source.initialColor || "#3f3f46" }}
        aria-hidden="true"
      >
        {source.initial}
      </span>
    );
  }

  return null;
};

export default ConnectSourceCatalogIcon;
